import { Chip } from "@mui/material";
import { HeatMaterial } from "../types";

export const HeatMixDiffPill = ({
  diffFromPreviousStage,
  format,
  highlighted,
}: {
  diffFromPreviousStage: HeatMaterial["diffFromPreviousStage"];
  format: (value: number) => string;
  highlighted: boolean;
}) => {
  const isVisiblyNonZero =
    format(Math.abs(diffFromPreviousStage)) !== format(0);
  const isPositive = diffFromPreviousStage > 0 && isVisiblyNonZero;
  const isNegative = diffFromPreviousStage < 0 && isVisiblyNonZero;

  const formatValue = (value: number) => {
    if (value > 0) return `+${format(value)}`;
    if (value === 0) return `±${format(value)}`;
    return format(value);
  };

  const getChipColor = () => {
    if (isPositive) return "success";
    if (isNegative) return "error";
    return "default";
  };

  return (
    <Chip
      sx={{
        fontWeight: highlighted ? "fontWeightBold" : "fontWeightMedium",
      }}
      label={formatValue(diffFromPreviousStage)}
      color={getChipColor()}
      variant="filled"
      size="small"
    />
  );
};
